import {
  useGetPublicSurveyByUUIDQuery,
  useGetPublicTeamHealthMetricsByUUIDQuery,
} from '../../../hooks/queries/useDashboardPublicQueries';
import type { TeamHealthMetrics } from '../../../api/queries';

export interface PublicSurveyData {
  survey: { title: string } | undefined;
  metrics: TeamHealthMetrics[];
  isLoadingSurvey: boolean;
  isLoadingMetrics: boolean;
  surveyError: unknown;
  metricsError: unknown;
}

export function usePublicSurveyData(guid: string | undefined): PublicSurveyData {
  const {
    data: survey,
    isLoading: isLoadingSurvey,
    error: surveyError,
  } = useGetPublicSurveyByUUIDQuery(guid!, {
    enabled: Boolean(guid),
  });

  const {
    data: metrics = [],
    isLoading: isLoadingMetrics,
    error: metricsError,
  } = useGetPublicTeamHealthMetricsByUUIDQuery(guid!, {
    enabled: Boolean(guid),
  });

  return {
    survey,
    metrics,
    isLoadingSurvey,
    isLoadingMetrics,
    surveyError,
    metricsError,
  };
}
